import React, { useRef, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import '../layout/sass/_pickListSugestoes.scss'
import '../layout/sass/_responsiveTable.scss'
import { Checkbox } from 'primereact/checkbox';
import { InputText } from 'primereact/inputtext';
import { Tag } from 'primereact/tag'

export const TabelaAlunosFalta = ({ alunos, setAlunos }) => {
  const toast = useRef(null);
  const confirmationToast = useRef(null);

  const codigoBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <p style={{ textAlign: 'left' }}>
          <span className="p-column-title">Matrícula</span>
          <span className="table-data">{rowData.matriculaId}</span>
        </p>
      </React.Fragment>
    );
  };

  const matriculaBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <p style={{ textAlign: 'left' }}>
          <span className="table-data">{rowData.matriculaNome}</span>
        </p>
      </React.Fragment>
    );
  };

  const nomeSocialBodyTemplate = (rowData) => {
    if (!rowData.nomeSocialAluno || rowData.nomeSocialAluno.trim() === "") {
      return null; // Não exibe nada
    }
    return (
      <React.Fragment>
        <p style={{ textAlign: 'left' }}>
          <span className="p-column-title">Nome Social </span>

          <Tag
            value={rowData.nomeSocialAluno}
            severity="info"
            style={{ fontSize: '0.85rem' }}
          />
        </p>
      </React.Fragment>
    );
  };

  const obsBodyTemplate = (rowData) => {
    const onObsChange = (e) => {
      setAlunos((prev) =>
        prev.map((aluno) =>
          aluno.id === rowData.id ? { ...aluno, obs: e.target.value } : aluno
        )
      );
    };

    return (
      <InputText
        value={rowData.obs}
        onChange={onObsChange}
        style={{ width: '100%' }}
      />
    );
  };

  const presenteBodyTemplate = (rowData) => {
    const handleChange = () => {
      rowData.presente = !rowData.presente;
      // Se o aluno não está presente, ele não pode estar atrasado
      if (!rowData.presente) {
        rowData.atrasado = false;
      }
      onRowEditComplete1({
        newData: rowData,
        index: alunos.indexOf(rowData),
      });
    };
    return (
      <React.Fragment>
        <Checkbox
          checked={rowData.presente}
          onChange={() => handleChange()}
          style={{ marginRight: '5px' }}
        />
      </React.Fragment>
    );
  };

  const atrasadoBodyTemplate = (rowData) => {
    const handleChange = () => {
      rowData.atrasado = !rowData.atrasado;
      // Se o aluno está atrasado, ele obrigatoriamente está presente
      if (rowData.atrasado) {
        rowData.presente = true;
      }
      onRowEditComplete1({
        newData: rowData,
        index: alunos.indexOf(rowData),
      });
    };
    return (
      <React.Fragment>
        <Checkbox
          checked={rowData.atrasado || false}
          onChange={() => handleChange()}
          style={{ marginRight: '5px' }}
        />
      </React.Fragment>
    );
  };

  useEffect(() => {
    // Monitoramento de mudanças na lista de alunos
  }, [alunos]);

  const onRowEditComplete1 = (e) => {
    let alunos2 = [...alunos];
    let { newData, index } = e;

    if (index !== -1) {
      alunos2[index] = newData;
      setAlunos(alunos2);
    }
  };

  return (
    <div className="card p-grid p-col-12 p-mx-0 p-p-0 p-mt-0">
      <Toast ref={toast} position="bottom-right" />
      <Toast ref={confirmationToast} position="bottom-center" />

      <div className="card p-col-12 datatable-responsive-demo">
        <div className="p-fluid">
          <DataTable
            editMode="row"
            onRowEditComplete={onRowEditComplete1}
            responsiveLayout="scroll"
            value={alunos}
            className="p-datatable-responsive-demo"
            emptyMessage="Nenhuma matrícula encontrada"
            dataKey="id"
            paginator
            rows={20}
            currentPageReportTemplate="Mostrando de {first} a {last} de {totalRecords} alunos"
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            rowsPerPageOptions={[20, 30, 40]}
            sortField="matriculaNome"
            sortOrder={1}
            removableSort
          >
            <Column
              field="id"
              header="Matrícula"
              sortable
              body={codigoBodyTemplate}
              style={{ width: '8%' }} // A largura deve ficar aqui
              alignHeader="left"       // Alinha o texto e o ícone sem quebrar o layout
            />

            <Column
              field="matriculaNome"
              header="Nome do Aluno"
              sortable
              body={matriculaBodyTemplate}
              headerStyle={{ textAlign: 'left', justifyContent: 'flex-start' }}
            />

            <Column
              field="nomeSocialAluno"
              header="Nome Social"
              sortable
              body={nomeSocialBodyTemplate}
              headerStyle={{ textAlign: 'left', justifyContent: 'flex-start' }}
            />

            <Column
              field="obs"
              header="Observação"
              sortable
              body={obsBodyTemplate}
              headerStyle={{ textAlign: 'left', justifyContent: 'flex-start' }}
            />

            <Column
              header="Presente"
              body={presenteBodyTemplate}
              style={{ width: '10%' }}
            />

            <Column
              header="Atrasado"
              body={atrasadoBodyTemplate}
              style={{ width: '10%' }}
            />
          </DataTable>
        </div>
      </div>
    </div>
  );
};